import React, { useEffect, useState } from 'react'
import { AiOutlineHome } from 'react-icons/ai'
import { PiChalkboardTeacherDuotone, PiChatDotsFill } from 'react-icons/pi'
import { HiUserGroup } from 'react-icons/hi'
import { CgProfile } from 'react-icons/cg'
import { BiGroup, BiLogOut } from 'react-icons/bi'
import { RxHome } from 'react-icons/rx'
import colors from 'tailwindcss/colors'
import { useNavigate } from 'react-router-dom'
import { Dropdown } from 'flowbite-react'
import { HiCog, HiCurrencyDollar, HiLogout, HiViewGrid } from 'react-icons/hi';
import { CustomFlowbiteTheme,Flowbite } from 'flowbite-react';
export default function UserNavbar({name,name_bangla}) {
  const navigator = useNavigate()
  const switchPath = (pathname) => {
    navigator(pathname)
  }
  const [theme, setTheme] = useState('')
  const [lan, setLan] = useState('bangla')
  useEffect(() => {
    if (localStorage.getItem('color-theme') === 'light') {
      setTheme('light')
    } else {
      setTheme('dark')
    }
    if (localStorage.getItem('language') === 'bangla') {
      setLan('bangla')
    } else {
      setLan('english')
    }
  }, [])
  const changeTheme = () => {
    console.log("change")
    if (localStorage.getItem('color-theme') === 'light') {
      console.log("dark")
      localStorage.setItem('color-theme', 'dark')
      setTheme("dark")
      document.documentElement.classList.add('dark');
    } else {
      localStorage.setItem('color-theme', 'light')
      setTheme('light')
      document.documentElement.classList.remove('dark');
      console.log("light")
    }
  }
  const changeLanguage = () => {
    console.log("change")
    if (localStorage.getItem('language') === 'english') {
      console.log("bangla")
      localStorage.setItem('language', 'bangla')
      setLan("bangla")
      document.documentElement.classList.add('bangla');
    } else {
      localStorage.setItem('language', 'english')
      setLan('english')
      document.documentElement.classList.remove('bangla');
      console.log("english")
    }
    window.location.reload()
  }

  const customTheme= {
    button: {
      color: {
        primary: 'bg-red-500 hover:bg-red-600',
      },
    },
  };
  

  return (
    <div className="flex flex-row w-screen z-10 h-20 md:flex-col md:w-screen bg-gray-100 fixed bottom-0 md:top-0 dark:bg-slate-800" style={{ alignItems: "space-between", justifyContent: "center" }}>
      <div className="home  flex flex-row">
        <div className="icon flex-1 items-center hidden md:flex w-20 h-20 ">
            <span class="font-bold text-2xl mx-4 text-pink-600 dark:text-pink-500">{lan=="bangla"?name_bangla:name} </span>
        </div>

        <div className="flex flex-1" style={{ justifyContent: "center" }}>
          <button className="icon flex flex-col w-20 h-20 md:w-30 md:tooltip md:tooltip-right md:tooltip-info " style={{ alignItems: "center", justifyContent: "center" }} data-tip="Home" onClick={() => switchPath
            ("/")}>
            <div className="md:hidden"><RxHome size={24} color={theme === "dark" ? "white" : "grey"} /></div>
            {lan=="english" && <div className='text-xs md:text-lg md:font-bold md:text-slate-800 hover:text-pink-500 dark:hover:text-pink-500 dark:text-white'>Home</div>}
            {lan=="bangla" && <div className='text-xs md:text-lg md:font-bold md:text-slate-800 hover:text-pink-500 dark:hover:text-pink-500 dark:text-white'>হোম</div>}
            <div className="divider hidden md:flex "></div>
          </button>
         
          <button className="icon flex flex-col w-20 h-20 md:w-30 md:tooltip md:tooltip-right md:tooltip-info" style={{ alignItems: "center", justifyContent: "center" }} data-tip="Create Project" onClick={() => switchPath
            ("/connect")}>
            <div className="md:hidden"><BiGroup size={24} color={theme === "dark" ? "white" : "grey"} /></div>
            {lan=="english" && <div className='text-xs md:text-lg md:font-bold md:text-slate-800 hover:text-pink-500 dark:hover:text-pink-500 dark:text-white'>Contact</div>}
            {lan=="bangla" && <div className='text-xs md:text-lg md:font-bold md:text-slate-800 hover:text-pink-500 dark:hover:text-pink-500 dark:text-white'>যোগাযোগ</div>}
            <div className="divider hidden md:flex"></div>
          </button>


        </div>

        <div className="md:flex flex-1 hidden mr-10" style={{ justifyContent: "flex-end",alignItems:"center" }}>
          <button onClick={changeTheme} type="button" class="flex w-20 h-20 text-gray-500 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm" style={{ alignItems: "center", justifyContent: "center" }}>
            {theme === 'light' && <svg id="theme-toggle-dark-icon" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path></svg>}
            {theme === 'dark' && <svg id="theme-toggle-light-icon" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" fill-rule="evenodd" clip-rule="evenodd"></path></svg>}
          </button>
          <button onClick={changeLanguage} type="button" class="flex w-20 h-20 text-gray-500 dark:text-gray-400 hover:bg-gray-300 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm" style={{ alignItems: "center", justifyContent: "center" }}>
            {lan === 'bangla' && <img src="https://i.postimg.cc/63QDL1YV/england-4854979.png" width="20px"/>}
            {lan === 'english' && <img src="https://i.postimg.cc/gkRkZnwz/bangladesh-9993444.png" width="20px"/>}
          </button>
          {/* <Flowbite theme={{ theme: customTheme }}>
          <Dropdown label="Profile">
            <Dropdown.Header>
              <span className="block text-sm">
                Bonnie Green
              </span>
              <span className="block truncate text-sm font-medium">
                bonnie@flowbite.com
              </span>
            </Dropdown.Header>
            <Dropdown.Item icon={HiViewGrid}>
              Dashboard
            </Dropdown.Item>
            <Dropdown.Item icon={HiCog}>
              Settings
            </Dropdown.Item>
            
            <Dropdown.Divider />
            <Dropdown.Item icon={HiLogout}>
              Sign out
            </Dropdown.Item>
          </Dropdown>
          </Flowbite> */}
        </div>
      </div>






    </div>
  )
}
